module.exports = __webpack_public_path__ + "static/media/nba-soccerball.ecf4c4f9.jpg";